import cx from "classnames";
import { Link, useRouteMatch } from "react-router-dom";

import { useTranslation } from "@mywheels/common/lib/translation";

import { useLangPrefixify, useRoutes } from "web/lib/i18n";
import { Spinner } from "web/ui";

import { useBlogCategories } from "./data";

type Props = {
  loading?: boolean;
};

export function BlogToolbar({ loading }: Props) {
  const { t } = useTranslation();

  const lp = useLangPrefixify();
  const routes = useRoutes();
  const m = useRouteMatch<{ filter?: string }>({
    path: "/:en(en)?/blog/:filter",
    exact: true,
  });

  const { data: blogCategories } = useBlogCategories();

  return (
    <div className="mb-6 -mx-1 flex align-center flex-wrap">
      <BlogFilterBtn
        selected={!m || m.params.filter === "alles"}
        text={t("Alles")}
        to={lp("/blog/alles")}
      />

      {blogCategories?.map((cat) => {
        return (
          <BlogFilterBtn
            key={cat.id}
            selected={m?.params.filter === cat.slug}
            text={cat.title}
            to={routes.BlogArchive.url({
              filter: cat.slug,
            })}
          />
        );
      })}

      {loading && <Spinner size="sm" />}
    </div>
  );
}

function BlogFilterBtn({ selected = false, to = "", text = "" }) {
  return (
    <Link
      className={cx(
        "font-display inline-block leading-[14px] m-1 p-[5px] whitespace-nowrap text-left border border-transparent rounded no-underline",
        selected ? "bg-blue text-white" : "bg-white text-cool hover:bg-gray100"
      )}
      to={to}
    >
      {text}
    </Link>
  );
}
